var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"border-left-0 border-right-0 border-md border rounded-0 rounded-md-1 panel-background"},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }